import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useHistory, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * 404 Not Found Page
 * Site-wide fallback for non-existent URLs
 */
const NotFound = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>Page Not Found | Spawnry</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Dark Header */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
        padding: '100px 0 4rem',
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8} lg={6}>
              <h1 style={{
                fontSize: 'clamp(5rem, 15vw, 8rem)',
                fontWeight: '700',
                color: 'rgba(99, 102, 241, 0.3)',
                marginBottom: '0'
              }}>
                404
              </h1>
              <h2 style={{
                color: 'white',
                fontWeight: '700',
                fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                marginBottom: '1rem'
              }}>
                Page Not Found
              </h2>
              <p style={{
                color: 'rgba(255, 255, 255, 0.7)',
                fontSize: '1.1rem',
                marginBottom: '2rem'
              }}>
                The page you're looking for doesn't exist or has been moved.
              </p>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link
                  to="/"
                  style={{
                    fontWeight: '600',
                    padding: '0.75rem 1.5rem',
                    background: 'white',
                    color: '#1a1a2e',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    transition: 'transform 0.2s, box-shadow 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 8px 24px rgba(0,0,0,0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Go Home
                </Link>
                <button
                  onClick={() => history.goBack()}
                  style={{
                    fontWeight: '600',
                    padding: '0.75rem 1.5rem',
                    background: 'transparent',
                    color: 'white',
                    borderRadius: '8px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.borderColor = 'white';
                    e.target.style.background = 'rgba(255,255,255,0.1)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                    e.target.style.background = 'transparent';
                  }}
                >
                  Go Back
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NotFound;
